var _a;
import { createActions } from 'redux-actions';
export var addError = (_a = createActions('ADD_ERROR', 'REMOVE_ERROR'), _a.addError), removeError = _a.removeError;
